// extracted by mini-css-extract-plugin
module.exports = {"medium":"MediumCard_medium__8bJ2Z"};